



















































import Component from 'vue-class-component'
import { Vue, Watch } from 'vue-property-decorator'
import VueScrollTo from 'vue-scrollto'

interface Answer {
  conditionColoring: string;
  conditionPermanent: string;
  conditionStraighPerm: string;
  conditionBleach: string;
  conditionVolume: string;
}

@Component
export default class HairQuestion extends Vue {
  public ready = false
  public value = {
    conditionColoring: '',
    conditionPermanent: '',
    conditionStraighPerm: '',
    conditionBleach: '',
    conditionVolume: ''
  }

  public questions = [
    {
      question: 'カラーリングの頻度',
      choices: [
        {
          string: '月に一回以上',
          value: 'A'
        },
        {
          string: '2~3ヶ月に一回',
          value: 'B'
        },
        {
          string: '4~6ヶ月に一回',
          value: 'C'
        },
        {
          string: '半年以上してない',
          value: 'D'
        },
        {
          string: 'してない',
          value: 'E'
        }
      ],
      answer: '',
      id: 'conditionColoring'
    },
    {
      question: 'パーマをかけている',
      choices: [
        {
          string: 'はい',
          value: 'A'
        },
        {
          string: 'いいえ',
          value: 'B'
        }
      ],
      answer: '',
      id: 'conditionPermanent'
    },
    {
      question: '縮毛矯正をしている',
      choices: [
        {
          string: 'はい',
          value: 'A'
        },
        {
          string: 'いいえ',
          value: 'B'
        }
      ],
      answer: '',
      id: 'conditionStraighPerm'
    },
    {
      question: 'ブリーチをしている',
      choices: [
        {
          string: 'はい',
          value: 'A'
        },
        {
          string: 'いいえ',
          value: 'B'
        }
      ],
      answer: '',
      id: 'conditionBleach'
    },
    {
      question: '髪のボリュームについて',
      choices: [
        {
          string: 'ボリュームを出したい',
          value: 'A'
        },
        {
          string: 'ボリュームを抑えたい',
          value: 'B'
        },
        {
          string: 'ボリュームは気にしていない',
          value: 'C'
        }
      ],
      answer: '',
      id: 'conditionVolume'
    }
  ]

  created () {
    window.scrollTo({
      top: 0
    })
  }

  @Watch('value', { deep: true })
  public onValueChanged (val: Answer) {
    if (val.conditionColoring !== '' && val.conditionPermanent !== '' && val.conditionStraighPerm !== '' && val.conditionBleach !== '' && val.conditionVolume !== '') {
      this.ready = true
    }
  }

  @Watch('questions', { deep: true })
  public onConditionPainValueChanged (newValue: any, oldValue: any) {
    if (newValue[0].answer !== this.value.conditionColoring) {
      this.value.conditionColoring = newValue[0].answer
      this.scroll('#conditionPermanent')
    }
    if (newValue[1].answer !== this.value.conditionPermanent) {
      this.value.conditionPermanent = newValue[1].answer
      this.scroll('#conditionStraighPerm')
    }
    if (newValue[2].answer !== this.value.conditionStraighPerm) {
      this.value.conditionStraighPerm = newValue[2].answer
      this.scroll('#conditionBleach')
    }
    if (newValue[3].answer !== this.value.conditionBleach) {
      this.value.conditionBleach = newValue[3].answer
      this.scroll('#conditionVolume')
    }
    if (newValue[4].answer !== this.value.conditionVolume) {
      this.value.conditionVolume = newValue[4].answer
    }
  }

  public setValue () {
    this.$emit('handle-parent', this.value)
  }

  public scroll (element: string) {
    const options = {
      easing: 'ease-in',
      offset: -60,
      force: true,
      cancelable: true
    }
    if (window.parent.screen.width <= 480) {
      VueScrollTo.scrollTo(element, 200, options)
    }
  }
}

